import React, { useState, useEffect } from 'react';
import {
  FlexBox,
  FlexBoxHorizontal,
  TextField,
  Typography,
  FlexBoxVertical,
} from '../../atoms';
import {
  SelectAllCheckBox,
  SearchButton,
} from '../../molecules';
import Menu from '../../../utils/menu';

const TestReportFilter = ({ data, onSearch }) => {
  const filterOptions = {
    ...data,
  };
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(''); // 검색어 상태 추가

  useEffect(() => {
    const newSelectedOptions = {
      sesn: [],
      certiType: [], 
      fabric: [], 
      passYn: [], 
    };

    setSelectedOptions(newSelectedOptions);
  }, [data]); 

  const handleSelectedOptions = (key, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSearch = () => {
    // searchValue 추가하여 전달
    const options = {
      ...Object.keys(selectedOptions).reduce((acc, key) => {
        acc[key] = selectedOptions[key].length === 0 ? data[key] : selectedOptions[key];
        return acc;
      }, {}),
      searchValue: searchValue // 검색어 추가
    };
    onSearch(options);
  }


  return (
    <FlexBoxHorizontal style={{height: '100px', backgroundColor: '#f1f1f1b8', borderRadius: '3px', margin: '10px 0 10px 0'}}>
      <FlexBoxHorizontal style={{ overflow: 'auto', justifyContent: 'flex-start' }}>
            <Menu 
                targetPaths={['/interstellar/X/test-report', '/interstellar/X/fabric-test-report']}
                menuItems={[
                  { path: '/interstellar/X/test-report', label: 'Test Report' },
                  { path: '/interstellar/X/fabric-test-report', label: 'Test Report Upload - Fabric' }
                ]}
                buttonStyle={{ left: '20px', top: '25px' }}
                position={{top: '20px', left: '-220px'}}
              />
            <div
            style={{
              width: '150px',
              margin: '0 7px 0 70px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.sesn}
              setSelected={(value) => handleSelectedOptions('sesn', value)}
              options={filterOptions.sesn}
              title={'시즌'}
              allSelectTitle="시즌 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.certiType}
              setSelected={(value) => handleSelectedOptions('certiType', value)}
              options={filterOptions.certiType}
              title={'인증유형'}
              allSelectTitle="인증유형 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.fabricType}
              setSelected={(value) => handleSelectedOptions('fabricType', value)}
              options={filterOptions.fabricType}
              title={'패브릭타입'}
              allSelectTitle="패브릭타입 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.passYn}
              setSelected={(value) => handleSelectedOptions('passYn', value)}
              options={filterOptions.passYn}
              title={'패스여부'}
              allSelectTitle="패스여부 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '250px',
              margin: '0 7px 0 0',
            }}
          >
            <TextField
              placeholder="패브릭/파일명/협력사/비고 검색"
              value={searchValue}
              onChange={(value) => setSearchValue(value)} // searchValue 상태 업데이트
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
            />
          </div>
          
          <SearchButton
            label={'검색'}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => handleSearch()}
          />
          </FlexBoxHorizontal>
          </FlexBoxHorizontal>
  );
};

export default TestReportFilter;
